<template>
  <!-- 门禁智能系统解决方案 -->
  <div class="content_app">
    <Banner :banner-h="$t('services.accessControlSystem.title')"
            :banner-p="$t('services.accessControlSystem.description')" :banner-img="Img1"></Banner>
    <scroll-animate>
      <div class="system_service_introduced">
        <img src="@/assets/img/service/access/access1.png" class="rfid-sys-img">
      </div>
    </scroll-animate>

    <scroll-animate>
      <div class="product_hardware">
        <h1>{{ $t('services.accessControlSystem.productHardware') }}</h1>
        <p>{{ $t('services.accessControlSystem.productHardwareDesc') }}</p>
      </div>
    </scroll-animate>
    <scroll-animate>
      <div class="involved_products">
        <h1>{{ $t('services.accessControlSystem.involvedProducts') }}</h1>
        <section class="disp-content core_box">
          <ul class="content_ul">
            <li v-for="(item, index) in deviceData" :key="index">
            <span class="content-img">
              <img :src="item.image">
            </span>
              <h3>
                {{ item.title }}
              </h3>
              <p>{{ item.contentText }}</p>
              <span class="span_jiantou el-icon-right" @click="deviceItemClick(item)">
            </span>
              <em></em>
              <em></em>
            </li>
          </ul>
        </section>
      </div>
    </scroll-animate>

  </div>

</template>

<script>
import Banner from "@/components/banner.vue";
import {entranceGuard} from "@/assets/js/entranceGuard";
import i18n from '@/plugins/i18n';
import ScrollAnimate from "../../components/ScrollAnimate.vue";

export default {
  components: {ScrollAnimate, Banner},
  mounted() {
  },
  methods: {
    deviceItemClick(data) {
      for (const item of entranceGuard) {
        if (item.categoryName == data.dataKey) {
          const categoryData = {name: item.categoryName}
          categoryData.options = []
          item.catgItem.forEach((it) => {
            categoryData.options.push(it)
          })
          sessionStorage.setItem("product", JSON.stringify(categoryData))
          this.$router.push({
            name: "productShow",
          })
          break
        }
      }
    }
  },
  data() {
    return {
      Img1: require("@/assets/img/banner-bg/shanmai1.jpg"),

      // 设备架构数据
      deviceData: [
        {
          // image: require("@/assets/img/service/access/刷卡读卡器 (1).jpg"),
          image: require("@/assets/img/goods/entranceGuard/accsCtlCrdReader/accsCtlCrdReader1.png"),
          title: this.$t('services.accessControlSystem.devices.cardReader.title'),
          // 查看设备详情的key
          dataKey: this.$t('entranceGuard.categoryName.cardReader'),
          category: "entranceGuard",
          contentText: this.$t('services.accessControlSystem.devices.cardReader.description'),
        },
        {
          image: require("@/assets/img/service/access/renlianji.png"),
          title: this.$t('services.accessControlSystem.devices.faceRecognition.title'),
          dataKey: this.$t('entranceGuard.categoryName.faceRecognition'),
          category: "entranceGuard",
          contentText: this.$t('services.accessControlSystem.devices.faceRecognition.description')
        },
        {
          image: require("@/assets/img/service/access/menjinkongzhiqi.jpg"),
          title: this.$t('services.accessControlSystem.devices.controller.title'),
          dataKey: this.$t('entranceGuard.categoryName.controller'),
          category: "entranceGuard",
          contentText: this.$t('services.accessControlSystem.devices.controller.description')
        },
        // {
        //   image: require("@/assets/img/service/access/kaiguan.jpg"),
        //   title: this.$t('services.accessControlSystem.devices.contactlessButton.title'),
        //   dataKey: this.$t('entranceGuard.categoryName.openButton'),
        //   category: "entranceGuard",
        //   contentText: this.$t('services.accessControlSystem.devices.contactlessButton.description')
        // }
      ]
    }
  },
}
</script>

<style scoped lang="scss">
@import "@/assets/css/serviceCommonCss";
</style>
